import {useState, useEffect, useCallback} from 'react';

const useLocalState = (localItem, initialState) => {
    if (!localStorage.getItem(localItem)) {
        localStorage.setItem(localItem, JSON.stringify(initialState));
    }

    const [loc, setState] = useState(JSON.parse(localStorage.getItem(localItem)));

    const setLoc = (newItem) => {
        localStorage.setItem(localItem, JSON.stringify(newItem));
        setState(newItem);
    }

    const handleStorage = useCallback((event) => {
        if (localStorage.getItem(localItem) !== null) {
            setState(JSON.parse(localStorage.getItem(localItem)));
        } else {
            if (localItem === 'localData') {
                localStorage.setItem(localItem, JSON.stringify({...initialState, toReset: true}));
            } else {
                localStorage.setItem(localItem, JSON.stringify(initialState));
            }
        }
    }, [localItem, initialState]);

    useEffect(() => {
        window.addEventListener('storage', handleStorage);
        return () => {
            return window.removeEventListener('storage', handleStorage);
        }
    }, [handleStorage]);


    return [loc, setLoc];
}

export default useLocalState;
